<template>
  <svg width="24" height="24" viewBox="0 0 24 24">
    <path d="M16 18H6V8H9V12.77L15.98 6L18 8.03L11.15 15H16V18Z" fill="white" />
  </svg>
</template>
